import React from "react"
import Spinners from "./Common/Spinner"
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"

const LoaderComponent = ({
  color = "light",
  loadingText = "Please wait...",
  className = "align-items-center justify-content-center",
}) => {
  return (
    <div className="spinner-wrapper">
      <Container fluid>
        <div className={`spinner-inner d-flex flex-column ${className} `}>
          <div className="d-flex align-items-center justify-content-center">
            <Spinner
              color="#024478"
              style={{
                height: "3rem",
                width: "3rem",
              }}
            />
          </div>
          <span style={{ marginTop: "8px" }}>{loadingText}</span>
        </div>
      </Container>
    </div>
  )
}

export default LoaderComponent
